export const PRODUCTION_DISCONNECT_LINK =
  'https://login.salesforce.com/lightning/app/tackle__Setup';
export const TEST_DISCONNECT_LINK =
  'https://test.salesforce.com/lightning/app/tackle__Setup';

export const INTEGRATIONS = 'integrations';

export const FEATURE_FLAGS = {
  CLOUD_CONNECTOR_AWS_INTEGRATIONS: 'cloud-connector-aws-integrations',
};
